module.exports = __webpack_public_path__ + "img/ys.4e9d78ca.png";